module.exports = __webpack_public_path__ + "static/media/amplify-logo.268375e9.png";